import { Directive, HostListener, Inject, NgModule} from '@angular/core';

import { ImageProvisioningService } from './gallery/imageprovider.service';

@Directive({
    selector: 'input[type=file][imageUpload]',
    standalone: false
})
export class ImageSelectionDirective
{
  constructor(
    @Inject(ImageProvisioningService)
        private provisionService: ImageProvisioningService)
  { }

  @HostListener('change', ['$event'])
  public async readFiles(event: Event): Promise<void>
  {
    this.provisionService.addUserFilesToGallery(
      event.target as HTMLInputElement);
  }
}

@NgModule({
  declarations: [ ImageSelectionDirective ],
  exports: [ ImageSelectionDirective ],
  providers: [ ImageProvisioningService ],
})
export class ImageSelectionDirectiveModule
{ }
